import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {

  private readonly INTEGRATION_KEY = '70f290a6-58b7-4fe6-7e29-f130e698c442.eu';

  constructor(private auth: AuthService) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.url.search('/api/pendo/') !== -1) {
      const pendoHeaders = {
        'Content-Type': 'application/json',
        'x-pendo-integration-key': this.INTEGRATION_KEY
      };
      const pendoReq = req.clone({
        headers: new HttpHeaders(pendoHeaders)
      });
      return next.handle(pendoReq);
    }

    const token = this.auth.getToken();

    const tokenReq = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` }
    });
    return next.handle(tokenReq);

  }

}